module.exports = __webpack_public_path__ + "img/promo3.2c8086a9.jpg";